export default __webpack_public_path__ + "static/media/404_image.8440f144.svg";